export default "__VITE_ASSET__CwCxbM1h__"